export const formElementSetup = ({height}) => `
    height:  ${height || 'var(--height-form-control)'};
    border-radius: var(--radius-form-control);
    width: 100%;
    position: relative;
`;

export const inElementUi = () => `
    font-weight: 400;
`;

export const insideFormElementSetup = ({height}) => `
    -webkit-appearance: none;
    -moz-appearance: none;
    background: none;
    border: none;
    overflow: hidden;
    height:  ${height || 'var(--height-form-control)'};
    width: 100%;
    padding: var(--padding-form-control);
    ${inElementUi()};
`;

export const fileTypeInput = (styleFile) => {
    if (styleFile)
        return `
        padding: 0;
        > div > div {
            padding: 0;
            background: none;
            border: none;
        }
        input {
            height: unset !important;
            padding: 0;
        }
        [type="file"] {
            color: var(--upload-file-text);
        }
        [type="file"]::-webkit-file-upload-button {
            background: var(--form-upload-file-btn-background);
            border: 1px solid var(--form-upload-file-btn-background);
            color: var(--form-upload-file-btn-text);

            border-radius: 4px;
            cursor: pointer;
            font-size: var(--text-size-small);
            outline: none;
            padding: 10px 25px;
            text-transform: uppercase;
            transition: all 1s ease;
        }
        [type="file"]::-webkit-file-upload-button:hover {
            background: var(--form-upload-file-btn-background-hover);
            border: 1px solid var(--form-upload-file-btn-background-hover);
        }
    `;
};

export const formSubDetailSetup = (type) => {
    if (type == 'sub')
        return `
        display: list-item;
        font-size: var(--text-size-default);
        font-weight: 700;
        margin-left:12px!important;
        
        ::marker {
            font-size: var(--text-size-default);
            color: var(--container-text-color-disabled-100);
        }
        `;
    else return ``;
};
